import { forwardRef } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import NRSecondaryLinkStyles from './NRSecondaryLink.styles';
import clsx from 'clsx';

const useStyles = makeStyles(NRSecondaryLinkStyles);

const NRSecondaryLink = forwardRef((props, ref) => {
  const classes = useStyles();
  const { value, handleOnClick, openNull = true, disabledClick, ...rest } = props;
  const isInteractive = !!handleOnClick && !disabledClick && (openNull || value > 0);
  return (
    <span
      ref={ref}
      {...rest}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      onKeyDown={event => {
        if (!isInteractive) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleOnClick();
        }
      }}
      onClick={!disabledClick ? () => (openNull ? handleOnClick() : value > 0 && handleOnClick()) : undefined}
      className={clsx(classes.styleBase, { [classes.activeLink]: (openNull || value > 0) && !disabledClick })}
    >
      {value}
    </span>
  );
});
export default NRSecondaryLink;
